function modifyOrderApi(payload, method) {
    fetch('/wp-json/xola/v1/modify-order', {
            method: 'PATCH',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: payload, method
        }
    )
        .then((response) => response.json())
    return true
}